import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-50">
      <div className="w-full px-4 md:px-6 py-14 md:py-20">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col lg:flex-row gap-10 lg:gap-20">
            <div className="lg:w-5/12">
              <Link to="/" className="inline-block">
                <span className="text-4xl md:text-5xl lg:text-6xl font-heading font-bold whitespace-nowrap">
                  SUPERBUY.WTF
                </span>
              </Link>
              <p className="mt-8 text-foreground-300 text-sm leading-relaxed max-w-md">
                The most trusted superbuy spreadsheet link directory. We curate and verify shopping links across all major categories, updated daily to ensure you always find the best products. Your gateway to smarter superbuy shopping.
              </p>
              <div className="flex items-center gap-4 mt-6">
                <a href="#" className="w-10 h-10 rounded-full border border-foreground-700 flex items-center justify-center hover:border-background-50 transition-colors cursor-pointer" aria-label="Twitter">
                  <i className="ri-twitter-x-line text-foreground-400"></i>
                </a>
                <a href="#" className="w-10 h-10 rounded-full border border-foreground-700 flex items-center justify-center hover:border-background-50 transition-colors cursor-pointer" aria-label="Instagram">
                  <i className="ri-instagram-line text-foreground-400"></i>
                </a>
                <a href="#" className="w-10 h-10 rounded-full border border-foreground-700 flex items-center justify-center hover:border-background-50 transition-colors cursor-pointer" aria-label="Discord">
                  <i className="ri-discord-line text-foreground-400"></i>
                </a>
                <a href="#" className="w-10 h-10 rounded-full border border-foreground-700 flex items-center justify-center hover:border-background-50 transition-colors cursor-pointer" aria-label="Reddit">
                  <i className="ri-reddit-line text-foreground-400"></i>
                </a>
              </div>
            </div>

            <div className="lg:w-3/12 flex flex-col gap-6">
              <div>
                <h4 className="text-xs font-semibold uppercase tracking-wider text-foreground-400 mb-3">Address</h4>
                <p className="text-sm text-foreground-300 leading-relaxed">
                  245 Shopping District Blvd<br />
                  Suite 880, Fashion Tower<br />
                  New York, NY 10001
                </p>
              </div>
              <div>
                <h4 className="text-xs font-semibold uppercase tracking-wider text-foreground-400 mb-3">Phone</h4>
                <p className="text-sm text-foreground-300">+1 (212) 555-0198</p>
              </div>
              <div>
                <h4 className="text-xs font-semibold uppercase tracking-wider text-foreground-400 mb-3">Email</h4>
                <p className="text-sm text-foreground-300">hello@superbuy.wtf</p>
              </div>
            </div>

            <div className="lg:w-4/12">
              <div className="w-full aspect-[4/3] rounded-lg overflow-hidden bg-foreground-800">
                <img
                  src="https://readdy.ai/api/search-image?query=Chic%20modern%20retail%20boutique%20interior%20with%20warm%20ambient%20lighting%20clean%20white%20walls%20displaying%20carefully%20curated%20fashion%20items%20on%20minimal%20wooden%20shelving%20natural%20stone%20flooring%20with%20potted%20olive%20trees%20scattered%20throughout%20editorial%20interior%20photography%20sophisticated%20yet%20welcoming%20atmosphere%20cream%20and%20warm%20oak%20tones%20luxury%20retail%20design%20aesthetic&width=800&height=600&seq=footer-img-v2&orientation=landscape"
                  alt="Superbuy Spreadsheet retail showcase"
                  title="Superbuy Spreadsheet - Curated Fashion"
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
              </div>
            </div>
          </div>

          <div className="mt-14 pt-8 border-t border-foreground-800">
            <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
              <p className="text-xs text-foreground-500">
                &copy; 2026 Superbuy Spreadsheet. All rights reserved.
              </p>
              <div className="flex items-center gap-6">
                <Link to="/" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors whitespace-nowrap">
                  Home
                </Link>
                <Link to="/articles/best-superbuy-spreadsheet-2026" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors whitespace-nowrap">
                  Blog
                </Link>
                <Link to="/" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors whitespace-nowrap">
                  Contact
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}